import React from "react"
import { FormControl, FormErrorMessage } from "@chakra-ui/react"

type Props = {
  message: string
}

const AccountLoginError: React.FC<Props> = ({ message }) => (
  <FormControl isInvalid>
    <FormErrorMessage justifyContent="center">{message?.toString()}</FormErrorMessage>
  </FormControl>
)

export default React.memo(AccountLoginError)
